import React, { Component, useContext } from "react";
import {
  Button,
  Card,
  useAccordionToggle,
  AccordionContext,
  Accordion,
} from "react-bootstrap";
import _ from "lodash";
import DetailItem from "../../../../components/detailItem";
import { toast } from "react-toastify";
import BaseFormComponent from "../../../../components/BaseFormComponent";
import { ActionTypes } from "../../../../enums/actionTypes";
import loanRequestService from "../../../../services/hybridAppraisal/loanRequestService";
import BaseListComponent, { IFilterData } from "../../../../components/BaseListComponent";
import { createFilterData, mapEntityList } from "../../../../services/utility/autoMapperService";
import { filterFieldData } from "../../../../components/tableComponents/itemsTable";
import appraisalActionService from "../../../../services/hybridAppraisal/appraisalActionService";

export function ContextAwareToggle({ eventKey, header }) {
  const currentEventKey = useContext(AccordionContext);
  const toggleOnClick = useAccordionToggle(eventKey);
  const isCurrentEventKey = currentEventKey === eventKey;
  const angleType = isCurrentEventKey ? "fa fa-angle-up" : "fa fa-angle-down";
  return (
    <Card.Header onClick={toggleOnClick} style={{ cursor: "pointer" }}>
      <b>{header}</b>
      <i
        className={angleType}
        aria-hidden="true"
        style={{ float: "right" }}
      ></i>
    </Card.Header>
  );
}

interface ExternalCreditAssessmentCheckFields {
  accountNumber: string;
  statementType: string;
  bankName: string;
}

class ExternalCreditAssessmentCheckForm extends BaseFormComponent<ExternalCreditAssessmentCheckFields> { }

interface ExternalCreditAssessmentCheckProps {
  item: any;
}

interface ExternalCreditAssessmentCheckState {
  item: any;
  updatingStatus: boolean;
  submitting: boolean;
  data: IFilterData;
  currentPage: number;
  tableItems: any;
  fetching: boolean;
  fetchingDetail: boolean;
  totalSize: number;
  filterValueInput: filterFieldData;
}

class ExternalCreditAssessmentList extends BaseListComponent<ExternalCreditAssessmentCheckState> { }

class ExternalCreditAssessmentCheck extends Component<ExternalCreditAssessmentCheckProps, ExternalCreditAssessmentCheckState> {
  constructor(props: ExternalCreditAssessmentCheckProps) {
    super(props);
    this.state = {
      item: {},
      updatingStatus: false,
      submitting: false,
      data: createFilterData([]) as IFilterData,
      currentPage: 1,
      fetching: false,
      fetchingDetail: false,
      tableItems: [],
      totalSize: 0,
      filterValueInput: []
    };
  }

  getActionTypeString = (actionType) => {
    switch (actionType) {
      case 2:
        return "Update";
      case 6:
        return "Approve";
      case 7:
        return "Decline";
      case 8:
        return "PushBack";
      case 9:
        return "Recall";
      default:
        return "";
    }
  };

  onFormSubmit(
    actionType,
  ): boolean {
    try {
      var action = this.getActionTypeString(actionType)
      this.setState(
        {
          // errors: appraisalValidationService.validateAppraisalProcessDetailForm(fields),
        },
        () => {
          return this.submit(action);

        }
      );
      this.setState({});
      return false;
    } catch (error) {
      return false;
    }
  }

  async submit(
    action
  ): Promise<boolean> {
    try {
      this.setState({ submitting: true });
      const payload: any = {};
      var curDT = new Date().toLocaleString()

      payload.action = action;
      payload.loanRequestId = this.props.item.id
      payload.systemProcessID = Number();
      payload.itemLevel = this.props.item.currentLevel;
      payload.errorMessage = "";
      payload.logType = "SystemType";
      payload.comment = "";
      payload.effectiveStatus = "Valid";
      payload.id = Number(0);
      payload.processResponse = {
        "actionId": 0,
        "score": 0,
        "result": "string",
        "response": "string",
        "id": 0,
        "dateCreated": curDT,
        "dateUpdated": curDT
      };
      payload.dateCreated = curDT;
      payload.dateUpdated = curDT;

      // console.log("payload: ", payload);
      const response = await appraisalActionService.RunSystemProcess(payload);
      if (response.status >= 200 && response.status <= 300) {
        toast.info(`Validation Initiated successfully!`, {
          autoClose: 6000,
          type: toast.TYPE.DEFAULT,
          hideProgressBar: false,
        });
      }
      this.setState({ submitting: false });
    }
    catch (error) {
      if (error.response.status === 409) {
        toast.error(error.response.data.detail, {
          autoClose: 6000,
          type: toast.TYPE.ERROR,
          hideProgressBar: false,
        });
      } else if (error.response.status === 400) {
        toast.error(error.response.data.errors[0], {
          autoClose: 6000,
          type: toast.TYPE.ERROR,
          hideProgressBar: false,
        });
      }
    } finally {
      this.setState({ submitting: false });
      return true;
    }
  }


  handlePageChange = async (currentPage: number, data?: IFilterData) => {
    currentPage = currentPage < 0 ? this.state.currentPage : currentPage;
    this.setState({ fetching: true });
    let dataClone = typeof data === "undefined" ? { ...this.state.data } : { ...data };
    try {
      const loanRequests = await loanRequestService.filterLoanRequests(
        {filters: dataClone, accessibleBranchCodes: null},
        Number(process.env.REACT_APP_DEFAULT_PAGESIZE) || 10,
        currentPage
      );
      this.setState({
        tableItems: mapEntityList({
          entityList: loanRequests.data.item2,
          properties: [
            { oldName: "customerName", newName: "Name" },
            { oldName: "phonenumber", newName: "phoneNumber" },
            { oldName: "gender", newName: "gender" },
            { oldName: "gender", newName: "gender" },
          ],
        }),
        currentPage,
        totalSize: loanRequests.data.item1,
        fetching: false,
      });
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status <= 499) {
        this.setState({ fetching: false });
      } else {
        this.setState({ fetching: false });
      }
    } finally {
      this.setState({ fetching: false });
    }
  };
  getFilteredItems = (data: IFilterData): IFilterData => {
    let filteredItems: IFilterData = {};
    Object.keys(data).forEach((key) => {
      if (data[key].item2 !== "") {
        filteredItems[key] = data[key];
      }
    });
    return filteredItems;
  };

  handleOnExport = async (type: string) => { };

  static getDerivedStateFromProps(nextProps: ExternalCreditAssessmentCheckProps, prevState) {
    return {
      item: nextProps.item,
    };
  }

  render() {
    const {
      item,
    } = this.props;

    return (
      <div className="container-fluid relative animatedParent animateOnce">
        <div className="animated fadeInUpShort go">
          <div className="row">
            <div className="col-md-12">
              <div className="form-row">
                <div className="col-md-12">
                  <div className="row my-3 mx-2">
                    <h3>
                      <b>External Credit Assessment</b>
                    </h3>
                  </div>
                  <div className="card">
                    <Accordion defaultActiveKey="0">
                      <div>
                        <Card>
                          <ContextAwareToggle
                            eventKey={`0`}
                            header={<React.Fragment>
                              <i
                                className="fa fa-info-circle"
                                aria-hidden="true"
                                style={{ color: "#878a8a" }}
                              ></i>{" "}
                              External Credit Assessment Check
                            </React.Fragment>}
                          ></ContextAwareToggle>
                          <Accordion.Collapse eventKey={`0`}>
                            <Card.Body>
                              <div style={{ paddingTop: "0px", paddingBottom: "0px" }}>
                                <div className="row">
                                  <div className="col-md-10">
                                    <dl className="row">
                                      {item.appraisalActions.length != 0 ? (
                                        <React.Fragment>
                                          <Button
                                            className="card-title float-right"
                                            size="sm"
                                            variant="success"
                                            onClick={() => { }}
                                            disabled={true}
                                          >
                                            <i className="fas fa-spinner fa-spin mr-3"></i>
                                            Processing....
                                          </Button>
                                        </React.Fragment>

                                      ) : (
                                        <React.Fragment>
                                          <Button
                                            className="center"
                                            size="sm"
                                            variant="primary"
                                            onClick={(ActionTypes.APPROVE, () => {
                                              this.onFormSubmit(
                                                ActionTypes.APPROVE
                                              );
                                            }
                                            )}
                                          >
                                            Initiate External Credit Assessment Check
                                          </Button>
                                        </React.Fragment>
                                      )}
                                    </dl>
                                  </div>
                                </div>
                              </div>
                            </Card.Body>
                          </Accordion.Collapse>
                        </Card>
                      </div>

                    </Accordion>
                  </div>

                  <div className="card mt-3">
                    <Accordion defaultActiveKey="0">
                      <div>
                        <Card>
                          <ContextAwareToggle
                            eventKey={`0`}
                            header={<React.Fragment>
                              <i
                                className="fa fa-info-circle"
                                aria-hidden="true"
                                style={{ color: "#878a8a" }}
                              ></i>{" "}
                              Credit Assessment Result
                            </React.Fragment>}
                          ></ContextAwareToggle>
                          <Accordion.Collapse eventKey={`0`}>
                            <Card.Body>
                              <div style={{ paddingTop: "0px", paddingBottom: "0px" }}>
                                <div className="row">
                                  <div className="col-md-5">
                                    <dl className="row">
                                      <DetailItem
                                        label="Result Status"
                                        labelSize={7}
                                        valueSize={3}
                                        value={item.appraisalActions.filter(x => x.systemProcessID === Number())[0]?.comment}
                                      />
                                    </dl>
                                  </div>
                                  <div className="col-md-5">
                                    <dl className="row">
                                      <DetailItem
                                        label="Application Score"
                                        labelSize={9}
                                        valueSize={2}
                                        value={item.appraisalActions.filter(x => x.systemProcessID === Number())[0]?.processResponse?.score}
                                      />
                                    </dl>
                                  </div>
                                  <div className="col-md-2 float-right">
                                    <Button
                                      size="sm"
                                      variant="primary"
                                      onClick={() => { }}
                                    >
                                      View Report
                                    </Button>
                                  </div>
                                </div>
                              </div>
                            </Card.Body>
                          </Accordion.Collapse>
                        </Card>
                      </div>
                    </Accordion>
                  </div>


                  <div className="form-row">
                    <div className="my-1 mx-2">
                      <button
                        className="btn btn-sm btn-outline-primary my-2"
                        style={{ cursor: "pointer" }}
                        type="button"
                        onClick={() => { }}
                      >
                        <React.Fragment>
                          <i className="far fa-save fa-lg mr-2" />{" "}
                          Save
                        </React.Fragment>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ExternalCreditAssessmentCheck;
